exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".smooth-dnd-container.vertical[data-v-c1b4b888] {\n  height: 100%;\n}", ""]);

// exports
